import React from 'react';
import { BiLoggerContextProvider } from '../../biLogger/BiLogger.context';
import SimpleDeviationGridBlock from '../_partials/SimpleDeviationGridBlock';
var DuperbrowseSidebarBlock = function (_a) {
    var deviation = _a.deviation, duperbrowseContext = _a.duperbrowseContext;
    if (!duperbrowseContext) {
        return null;
    }
    return (React.createElement(BiLoggerContextProvider, { value: {
            sectionname: 'duperbrowse',
            _rankOffset: 0,
        } },
        React.createElement(SimpleDeviationGridBlock, { streamKey: "duperbrowse", deviations: duperbrowseContext, parentDeviation: deviation, titleOverride: "Duperbrowse" })));
};
DuperbrowseSidebarBlock.displayName = 'DuperbrowseSidebarBlock';
export default DuperbrowseSidebarBlock;
//# sourceMappingURL=DuperbrowseSidebarBlock.js.map